export const ttfPercentiles = [
  { percentile: 0.0, z_score: -2.977861802 },
  { percentile: 0.01, z_score: -1.783278744 },
  { percentile: 0.02, z_score: -1.633522618 },
  { percentile: 0.03, z_score: -1.529619088 },
  { percentile: 0.04, z_score: -1.44630524 },
  { percentile: 0.05, z_score: -1.377105539 },
  { percentile: 0.06, z_score: -1.31686017 },
  { percentile: 0.07, z_score: -1.263298779 },
  { percentile: 0.08, z_score: -1.215139321 },
  { percentile: 0.09, z_score: -1.171709912 },
  { percentile: 0.1, z_score: -1.130802767 },
  { percentile: 0.11, z_score: -1.092850872 },
  { percentile: 0.12, z_score: -1.056944914 },
  { percentile: 0.13, z_score: -1.023261721 },
  { percentile: 0.14, z_score: -0.9909389757 },
  { percentile: 0.15, z_score: -0.9605015688 },
  { percentile: 0.16, z_score: -0.9314976922 },
  { percentile: 0.17, z_score: -0.903384243 },
  { percentile: 0.18, z_score: -0.8767132002 },
  { percentile: 0.19, z_score: -0.8508533972 },
  { percentile: 0.2, z_score: -0.82551478 },
  { percentile: 0.21, z_score: -0.8012785981 },
  { percentile: 0.22, z_score: -0.7779417852 },
  { percentile: 0.23, z_score: -0.7550070724 },
  { percentile: 0.24, z_score: -0.7324052464 },
  { percentile: 0.26, z_score: -0.6889687897 },
  { percentile: 0.27, z_score: -0.667832802 },
  { percentile: 0.28, z_score: -0.6468541915 },
  { percentile: 0.29, z_score: -0.6260637848 },
  { percentile: 0.3, z_score: -0.6057162305 },
  { percentile: 0.31, z_score: -0.5857673603 },
  { percentile: 0.32, z_score: -0.5660544268 },
  { percentile: 0.33, z_score: -0.5461355699 },
  { percentile: 0.34, z_score: -0.5264158172 },
  { percentile: 0.35, z_score: -0.5062225296 },
  { percentile: 0.36, z_score: -0.4865015926 },
  { percentile: 0.37, z_score: -0.4665838198 },
  { percentile: 0.38, z_score: -0.4468050694 },
  { percentile: 0.39, z_score: -0.4268854727 },
  { percentile: 0.4, z_score: -0.4068195085 },
  { percentile: 0.41, z_score: -0.3867167941 },
  { percentile: 0.42, z_score: -0.3660572432 },
  { percentile: 0.43, z_score: -0.3452497412 },
  { percentile: 0.44, z_score: -0.3240108538 },
  { percentile: 0.45, z_score: -0.3025970761 },
  { percentile: 0.46, z_score: -0.2805012796 },
  { percentile: 0.47, z_score: -0.2578339028 },
  { percentile: 0.48, z_score: -0.235236144 },
  { percentile: 0.49, z_score: -0.2122418848 },
  { percentile: 0.5, z_score: -0.1887635518 },
  { percentile: 0.51, z_score: -0.1648146472 },
  { percentile: 0.52, z_score: -0.140478171 },
  { percentile: 0.53, z_score: -0.1157087223 },
  { percentile: 0.54, z_score: -0.09048603168 },
  { percentile: 0.55, z_score: -0.06446662878 },
  { percentile: 0.56, z_score: -0.0382149442 },
  { percentile: 0.58, z_score: 0.01611546746 },
  { percentile: 0.59, z_score: 0.0443695571 },
  { percentile: 0.6, z_score: 0.07339557867 },
  { percentile: 0.61, z_score: 0.1030475278 },
  { percentile: 0.62, z_score: 0.1335325975 },
  { percentile: 0.63, z_score: 0.1648891362 },
  { percentile: 0.64, z_score: 0.1974693486 },
  { percentile: 0.65, z_score: 0.2305585723 },
  { percentile: 0.66, z_score: 0.2647526108 },
  { percentile: 0.67, z_score: 0.2998081399 },
  { percentile: 0.68, z_score: 0.3356725419 },
  { percentile: 0.69, z_score: 0.3719714245 },
  { percentile: 0.7, z_score: 0.4089844225 },
  { percentile: 0.71, z_score: 0.4463148725 },
  { percentile: 0.72, z_score: 0.484015348 },
  { percentile: 0.73, z_score: 0.5227298005 },
  { percentile: 0.74, z_score: 0.5617935626 },
  { percentile: 0.75, z_score: 0.6016781501 },
  { percentile: 0.76, z_score: 0.6418747063 },
  { percentile: 0.77, z_score: 0.6837450778 },
  { percentile: 0.78, z_score: 0.7269650624 },
  { percentile: 0.79, z_score: 0.771628752 },
  { percentile: 0.8, z_score: 0.8176563649 },
  { percentile: 0.81, z_score: 0.8659792147 },
  { percentile: 0.82, z_score: 0.9164853212 },
  { percentile: 0.83, z_score: 0.9692250677 },
  { percentile: 0.84, z_score: 1.024518375 },
  { percentile: 0.85, z_score: 1.083570741 },
  { percentile: 0.86, z_score: 1.146402512 },
  { percentile: 0.87, z_score: 1.21364326 },
  { percentile: 0.88, z_score: 1.285297736 },
  { percentile: 0.89, z_score: 1.361508543 },
  { percentile: 0.9, z_score: 1.442761125 },
  { percentile: 0.91, z_score: 1.529683515 },
  { percentile: 0.92, z_score: 1.622867364 },
  { percentile: 0.93, z_score: 1.723927657 },
  { percentile: 0.94, z_score: 1.832096944 },
  { percentile: 0.95, z_score: 1.950837528 },
  { percentile: 0.96, z_score: 2.083393301 },
  { percentile: 0.97, z_score: 2.239550771 },
  { percentile: 0.98, z_score: 2.43744218 },
  { percentile: 0.99, z_score: 2.724361238 },
  { percentile: 1.0, z_score: 3.574304714 },
];
